<template>
    <v-overlay :value="dialog">
        <v-dialog
            v-model="dialog"
            persistent
            fullscreen
            content-class="d-flex justify-center align-center"
        >
            <div
                class="d-flex flex-column justify-center align-center elevation-15 message-content border-radius-2"
            >
                <div class="d-flex flex-column justify-center align-center position-relative">
                    <div class="pa-5 mx-5 d-flex justify-center align-center flex-column">
                        <div class="mb-2">
                            <span class="text-h5 primary--text pa-5 font-weight-lighter text-capitalize">
                                {{ `${$t('from')} ${$utils.upperFirstLetter(message_data.fromUser.firstname)}` }}
                            </span>
                        </div>
                        <div class="mb-2">
                            <span class="text-h5 primary--text pa-5 font-weight-lighter">
                                {{ message_data.subject }}
                            </span>
                        </div>
                        <div>
                            <span class="text-subtitle-1 primary--text pa-5 font-weight-lighter">
                                {{ ramingTime }}
                            </span>
                        </div>
                        <div class="max-heigth-msg px-10 pt-5">
                            <span
                                class="text-body-1 primary--text font-weight-lighter"
                                v-html="message_data.message"
                            >
                            </span>
                        </div>
                    </div>
                    <v-card-actions class="d-flex justify-center align-center ma-4">
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" class="px-10 py-5" rounded @click="close">
                            {{ $t('exit') }}
                        </v-btn>
                    </v-card-actions>
                </div>
            </div>
        </v-dialog>
    </v-overlay>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
        message_data: { type: Object, default: null },
    },
    data() {
        return {
            varitaImg: require('@/assets/img/icons/beecoins-1.svg'),
            absolute: true,
        }
    },
    computed: {
        ramingTime() {
            return this.$moment(this.message_data.issueDate).fromNow()
        },
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
    },
}
</script>
<style>
.bee-img {
    width: 15vh;
    text-align: left;
    top: 2.5vh;
    left: 2.5vh;
    line-height: 1.5vh;
}
.bee-img span {
    font-size: 12px !important;
    font-weight: 400;
    letter-spacing: 1px !important;
}
.bee-img img {
    height: 5vh;
}
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
.message-content {
    width: 35%;
    box-sizing: border-box;
    border: 2px solid #4bada1;
    background: radial-gradient(circle, #f4f9f9 0%, #ceecea 100%);
    box-shadow: -7px 6px 12px 5px rgba(0, 0, 0, 0.07);
}

.max-heigth-msg {
    max-height: 50vh;
    overflow: auto;
}
</style>
